import { Component, computed, input, output } from '@angular/core';
import { ProductKeys } from '@config/keys/product.keys';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { DoodProductModel } from '@core/models/product.model';
import { ContentBuilderColorPipe } from '@core/pipes/content-builder-color.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonAtomComponent } from '@shared/atoms/button-atom/button-atom.component';
import { PriceAtomComponent } from '@shared/atoms/price-atom/price-atom.component';
import { TagAtomComponent } from '@shared/atoms/tag-atom/tag-atom.component';
import { RadialGradientDirective } from '@shared/directives/radial-gradient.directive';
import { VisibleLabelsPipe } from '@shared/pipes/visible-product-labels/visible-product-labels.pipe';
import { hasDiscountPromotionLabel } from '@core/services/eligible-promotions-labels/has-discount-promotion-label.util';
import { KioskProductCardInputs } from '../kiosk-product-card-factory/kiosk-product-cart';

@Component({
  selector: 'app-kiosk-product-card-v2-atom',
  templateUrl: './kiosk-product-card-v2-atom.component.html',
  imports: [
    ContentBuilderColorPipe,
    ButtonAtomComponent,
    TranslatePipe,
    PriceAtomComponent,
    TagAtomComponent,
    VisibleLabelsPipe,
    RadialGradientDirective,
  ],
  styles: `
    :host {
      @apply h-full relative;
    }
    :host.borderedCard {
      @apply rounded border border-solid border-neutral-300 bg-neutral-50 p-1;
      > div {
        @apply rounded p-1;
      }
      .unavailable-background {
        @apply rounded;
      }
    }

    :host.shadowCard {
      box-shadow: var(--kiosk-card-shadow);
      @apply p-2;
    }
  `,
})
export class KioskProductCardV2AtomComponent implements KioskProductCardInputs {
  readonly product = input.required<DoodProductModel>();
  readonly quantity = input.required<number | undefined>();
  readonly isProductAvailable = input<boolean | undefined>(true);
  readonly textColor = input<IContentBuilderFieldColor>();
  readonly cardColor = input<IContentBuilderFieldColor>();
  readonly buttonBackgroundColor = input<IContentBuilderFieldColor>();
  readonly unavailableButtonBackground = input<IContentBuilderFieldColor>();
  readonly unavailableButtonText = input<IContentBuilderFieldColor>();
  readonly buttonTextColor = input<IContentBuilderFieldColor>();
  readonly priceColor = input<IContentBuilderFieldColor>();
  readonly isShowProductIcon = input<boolean>(true);

  readonly addProduct = output<void>();
  readonly showProduct = output<void>();

  public get ProductKeys(): typeof ProductKeys {
    return ProductKeys;
  }

  displayDiscount = computed(() => {
    const product = this.product();
    const discount = product[ProductKeys.Discount] ?? 0;
    return discount > 0;
  });

  discountPercentage = computed(() => {
    const product = this.product();
    const originalPrice = product[ProductKeys.Price];
    const discount = product[ProductKeys.Discount] ?? 0;

    if (originalPrice <= 0 || discount <= 0 || originalPrice <= discount) {
      return 0;
    }

    const discountAmount = originalPrice - discount;
    const discountPercentage = Math.round((discountAmount / originalPrice) * 100);
    return discountPercentage;
  });

  addToCart(): void {
    this.addProduct.emit();
  }

  showProductModal(): void {
    this.showProduct.emit();
  }

  protected readonly _hasDiscountPromotionLabel = computed(() =>
    hasDiscountPromotionLabel(this.product()),
  );
}
